(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-results"] && !Shopify.designMode) return;
  try {
    
  // Cuenta de 0 al porcentaje (número y anillo) cuando la sección entra en pantalla.
  // Sin JS o con "reducir movimiento" se queda el valor final que ya trae el HTML.
  if (!customElements.get('results-counter')) {
    customElements.define(
      'results-counter',
      class ResultsCounter extends HTMLElement {
        connectedCallback() {
          this.circles = [...this.querySelectorAll('[data-count-to]')];
          if (!this.circles.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.circles.forEach((circle) => this.render(circle, 0));
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.animate();
            },
            { threshold: 0.4 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        render(circle, value) {
          circle.style.setProperty('--percentage', `${value}%`);
          const label = circle.querySelector('p');
          if (label) label.textContent = `${Math.round(value)}%`;
        }

        animate() {
          const duration = 1600;
          const start = performance.now();
          const step = (now) => {
            const progress = Math.max(0, Math.min((now - start) / duration, 1));
            const eased = 1 - Math.pow(1 - progress, 3);
            this.circles.forEach((circle) => this.render(circle, Number(circle.dataset.countTo) * eased));
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-review"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-slider')) {
    customElements.define(
      'review-slider',
      class ReviewSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-slider-track]');
          this.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.go(-1));
          this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.go(1));
        }

        go(direction) {
          const { scrollLeft, clientWidth, scrollWidth } = this.track;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const behavior = reduceMotion ? 'auto' : 'smooth';
          const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
          const atStart = scrollLeft <= 0;

          if (direction > 0 && atEnd) {
            this.track.scrollTo({ left: 0, behavior });
          } else if (direction < 0 && atStart) {
            this.track.scrollTo({ left: scrollWidth, behavior });
          } else {
            this.track.scrollBy({ left: direction * clientWidth, behavior });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
